import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserInfo } from '@core/services/user-info';
import { catchError, throwError } from 'rxjs';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const userInfo = inject(UserInfo);
  const accessToken = userInfo.getAccessToken();

  const modifiedReq = accessToken
    ? req.clone({
        headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
      })
    : req;

  return unauthorizedInterceptor(modifiedReq, next);
};

const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const userInfo = inject(UserInfo);
  const router = inject(Router);

  return next(req).pipe(
    catchError((responseError: HttpErrorResponse) => {
      if (responseError.status === 401) {
        userInfo.clear();
        void router.navigate(['/auth/login']);
      }

      return throwError(() => responseError);
    }),
  );
};
